import { TutorAuthority, TutorConfig } from "../entities/tutor";

export function checkIsAdminOrOwnerOfSchoolFromAuthority(
  authority: TutorAuthority
): boolean {
  return ["admin", "owner"].includes(authority);
}

export function isAdminOrOwnerOfSchool(tutorConfig: TutorConfig): boolean {
  return checkIsAdminOrOwnerOfSchoolFromAuthority(tutorConfig.data.authority);
}

export function isOwnerOfSchool(tutorConfig: TutorConfig) {
  return tutorConfig.data.authority === "owner";
}

export const getAuthorityMap = ({
  isSchool
}: {
  isSchool: boolean;
}): Record<TutorAuthority, string> =>
  isSchool
    ? {
        owner: "管理職",
        admin: "ICT担当者",
        supervisor: "先生", //スクール領域では存在しないはずの権限
        employee: "先生",
        privateTutor: "家庭教師",
        general: "先生" //スクール領域では存在しないはずの権限
      }
    : {
        owner: "オーナー",
        admin: "管理者",
        supervisor: "責任者",
        employee: "担当者",
        privateTutor: "家庭教師",
        general: "一般"
      };

/**
 * 権限の表示名からTutorAuthorityへの逆引きマップを生成
 * スクールの場合は実際に使用される権限(owner, admin, employee)のみをマッピング
 */
export const getAuthorityReverseMap = ({
  isSchool
}: {
  isSchool: boolean;
}): Record<string, TutorAuthority> => {
  const authorityMap = getAuthorityMap({ isSchool });
  const reverseMap: Record<string, TutorAuthority> = {};

  // スクールの場合、実際に使用される権限のみをマッピング
  // supervisor と general は存在しないので除外
  const validAuthorities: TutorAuthority[] = isSchool
    ? ["owner", "admin", "employee"]
    : ["owner", "admin", "supervisor", "employee", "general"];

  for (const authority of validAuthorities) {
    const displayName = authorityMap[authority];
    reverseMap[displayName] = authority;
  }
  return reverseMap;
};

// ============================================
// 個別バリデーション関数
// ============================================

/**
 * スタッフ名のバリデーション
 */
export function validateTutorName(name: string): boolean {
  return name.trim().length > 0;
}

/**
 * 権限名（表示名）のバリデーション
 */
export function validateAuthorityDisplayName(
  authorityDisplayName: string,
  validAuthorities: string[]
): boolean {
  if (!authorityDisplayName) return false;
  return validAuthorities.includes(authorityDisplayName);
}

/**
 * 教室名一覧のバリデーション
 */
export function validateClassroomNames(
  classroomNames: string[],
  validClassroomNames: string[]
): boolean {
  if (!classroomNames.length) return true;
  return classroomNames.every(name => validClassroomNames.includes(name));
}

/**
 * パスワードのバリデーション
 */
export function validateTutorPassword(password: string): boolean {
  return /^[a-zA-Z0-9!-/:-@¥[-`{-~]{8,64}$/.test(password);
}
